import React from "react";
import Button from "@mui/material/Button";
import { withLocalizer } from "utilities/withLocalizer";

function NextButton(props) {
    let { data, events } = props;
    let { currentStep, allTermsReviewed } = data;
    if (currentStep >= 7) return;
    
    const labelKey = "qma-navigation-step" + currentStep + "-next";

    return (
        <div className="wizard-button pull-right" >
            {(currentStep !== 5 || (currentStep === 5 && allTermsReviewed)) ?
                <Button className="btn-white-blue" data-testid="info-btn" variant="contained" onClick={() => {
                    events?.isStepDataValid(true, currentStep);
                }}>
                    {props.localize(labelKey)}
                </Button>
                : <Button className="btn-white-blue" disabled data-testid="info-btn" variant="disabled" onClick={() => {
                    events?.isStepDataValid(true, currentStep);
                }}>
                    {props.localize(labelKey)}
                </Button>
            }
            
        </div>
    );
}

export default withLocalizer(NextButton);